module.exports = __webpack_public_path__ + "static/media/corporate-account.a21f9cbc.svg";